import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CardValue } from '../../models/communication/cards.enum';
import { CardPosition } from '../../models/communication/games.model';
import { ResultChange } from '../../services/result-change.service';
import { CardComponent } from '../cards/card/card.component';

/**
 * The component generates the suits and cards menu and
 * enables the user interactions with the ResultChange service.
 */
@Component({
    selector: 'app-result-change',
    standalone: true,
    imports: [CommonModule, CardComponent],
    templateUrl: './result-change.component.html',
    styleUrl: './result-change.component.scss'
})
export class ResultChangeComponent implements OnInit {
    @Input()
    enabled = false;

    @Output()
    readonly resultChangeConfirmed = new EventEmitter<{
        button: HTMLButtonElement;
        data: Partial<Record<CardPosition, { old: CardValue; new: CardValue }>>;
    }>();

    @Output()
    readonly resultChangeClosed = new EventEmitter<HTMLButtonElement>();

    protected readonly cardNumbers = Array.from({ length: 13 }, (_, i) => i + 1);
    protected readonly cardSuits = [
        { id: 300, name: 'heart' },
        { id: 100, name: 'club' },
        { id: 200, name: 'diamonds' },
        { id: 400, name: 'spade' }
    ];
    protected selectedSuitId = this.cardSuits[0].id;

    constructor(protected readonly resultChange: ResultChange) {}

    ngOnInit(): void {
        this.resultChange.open();
    }

    protected selectCard(cardValue: CardValue): void {
        this.resultChange.changeCardValue(cardValue);
    }

    protected confirm(button: HTMLButtonElement): void {
        const data = this.resultChange.confirm();
        this.resultChangeConfirmed.emit({ button, data });
    }

    protected close(button: HTMLButtonElement): void {
        this.resultChange.close();
        this.resultChangeClosed.emit(button);
    }
}
